import * as React from 'react';

/**
 * Simple React.useState wrapper to set the anchor ref with typings
 *
 * @returns - A tuple of the element ref and the setRef func
 */
 export function useHelpPopperAnchorRef(): [
    HTMLElement | null,
    React.Dispatch<React.SetStateAction<HTMLElement | null>>,
] {
    const [ele, setEle] = React.useState<HTMLElement | null>(null);
    return [
        ele,
        el => {
            if (!ele && el) {
                setEle(el);
            }
        },
    ];
}

